import apiReporting from '@/api/reporting'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createReportingStart: '[create reporting] Create reporting start',
  createReportingSuccess: '[create reporting] Create reporting success',
  createReportingFailure: '[create reporting] Create reporting failure',
}

export const actionTypes = {
  createReporting: '[create reporting] Create reporting',
}

const mutations = {
  [mutationTypes.createReportingStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createReportingSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createReportingFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.createReporting](context, {reporting}) {
    context.commit(mutationTypes.createReportingStart)
    return new Promise((resolve) => {
      apiReporting
        .createReporting(reporting)
        .then((response) => {
          context.commit(mutationTypes.createReportingSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createReportingFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
